<template>
  
  <div v-if="!loading">
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
         <h1>Home</h1> 
          <v-carousel>
    <v-carousel-item
       v-for="ad in promoAds"
       :key="ad.id"
       :src="ad.imageSrc"
    >
      <div class="car-link"> 
        <v-btn  class="error" :to="'/ad/' + ad.id">
            {{ad.title}}
          </v-btn>
      </div>
    </v-carousel-item>
  </v-carousel>
       </v-flex>
 </v-layout>
 
  </v-container>
 
   <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex
       xs12
       sm6
       md4
        v-for="ad in ads"
        :key="ad.id"
       >
         <v-card
    class="mx-auto"
    max-width="344"
  >
    <v-img
      :src="ad.imageSrc"
      height="200px"
    ></v-img>

    <v-card-title>
       {{ad.title}}
    </v-card-title>

    <v-card-subtitle>
     <div>{{ad.description}}</div>
    </v-card-subtitle>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text flat :to="'/ad/'+ad.id">Open</v-btn>
      <!-- <app-buy-modal></app-buy-modal> -->
      <app-buy-modal :ad="ad"></app-buy-modal>
      <v-btn
        color="purple"
        text
      >
        Explore
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        icon
        @click="show = !show"
      >
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text>
          I'm a thing. But, like most politicians, he promised more than he could deliver. You won't have time for sleeping, soldier, not with all the bed making you'll be doing. Then we'll go with that data file! Hey, you add a one and two zeros to that or we walk! You're going to do his laundry? I've got to find a way to escape.
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>

      </v-flex>

    </v-layout>

    </v-container>
  </div>

<div v-else>
  <v-container>
    <v-layout row>
      <v-flex xs12 class="text-xs-center pt-5">
         <v-progress-circular
      :size="100"
      :width="4"
      color="purple"
      indeterminate
      ></v-progress-circular>
      </v-flex>
      
    </v-layout>
  </v-container>
</div>
</template>
<script>
  export default{
     computed:{
      promoAds () {
        return this.$store.getters.promoAds
      },
      ads () {
         return this.$store.getters.ads
      },
      loading () {
        return this.$store.getters.loading
        //это будет проверяться в корневом диве
      }

     }
  }
  
</script>

<style scoped lang="stylus">
  .car-link 
    position: absolute;
    bottom: 50px;
    left: 50%;
    background: rgba(0,0,0, 0.5);
    transform: translate(-50%,0);
    padding: 5px 15px;
   
    border-top-right-radius: 5px;
    border-top-right-radius: 5px;

  
</style>